export const SectionSix = () => {
  const scrollToTop = () => {
    const isMobileOrTablet = window.innerWidth <= 991;
    window.scrollTo({
      top: isMobileOrTablet ? 350 : 100,
      behavior: "smooth",
    });
  };

  return (
    <div className="section-six ">
      <div className="contact-detail">
        <h4>Let's talk.</h4>
        <p>Scale your eCommerce business faster with GoKwik.</p>
        <div className="specific-bullet">
          <img src="assets/images/kwikcheckoutcod/tick.svg" alt="tick" />{" "}
          <span>Personalised walkthrough of the product</span>
        </div>
        <div className="specific-bullet">
          <img src="assets/images/kwikcheckoutcod/tick.svg" alt="tick" />{" "}
          <span>Expert advice on maximising conversions</span>
        </div>
        <button onClick={scrollToTop}>Book a Demo</button>
      </div>
      <div className="image">
        <img
          src="assets/images/kwikcheckoutcod/hand-shake.png"
          alt="Handshake Image"
        />
      </div>
    </div>
  );
};
